import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface Notification {
  message: string;
  type: 'success' | 'error' | 'warning' | 'info';
  duration?: number;
}

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private notificationSubject = new Subject<Notification>();
  public notification$ = this.notificationSubject.asObservable();

  showSuccess(message: string, duration: number = 3000): void {
    this.show({ message, type: 'success', duration });
  }

  showError(message: string, duration: number = 5000): void {
    this.show({ message, type: 'error', duration });
  }

  showWarning(message: string, duration: number = 4000): void {
    this.show({ message, type: 'warning', duration });
  }

  showInfo(message: string, duration: number = 3000): void {
    this.show({ message, type: 'info', duration });
  }

  /** @deprecated Use showSuccess() */
  success(message: string, _action?: string): void {
    this.showSuccess(message);
  }

  /** @deprecated Use showError() */
  error(message: string, _action?: string): void {
    this.showError(message);
  }

  /** @deprecated Use showWarning() */
  warning(message: string, _action?: string): void {
    this.showWarning(message);
  }

  /** @deprecated Use showInfo() */
  info(message: string, _action?: string): void {
    this.showInfo(message);
  }

  private show(notification: Notification): void {
    this.notificationSubject.next(notification);
  }
}
